export default __webpack_public_path__ + "static/media/waterfowl.bebb64ff.webp";